var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCastle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640 176V480C640 497.672 625.674 512 608 512H384V384C384 348.652 355.346 320 320 320S256 348.652 256 384V512H32C14.326 512 0 497.672 0 480V176C0 167.162 7.164 160 16 160H64C72.836 160 80 167.162 80 176V224H128V16C128 7.162 135.164 0 144 0H192C200.836 0 208 7.162 208 16V64H240V16C240 7.162 247.164 0 256 0H288C296.836 0 304 7.162 304 16V64H336V16C336 7.162 343.164 0 352 0H384C392.836 0 400 7.162 400 16V64H432V16C432 7.162 439.164 0 448 0H496C504.836 0 512 7.162 512 16V224H560V176C560 167.162 567.164 160 576 160H624C632.836 160 640 167.162 640 176Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCastle);
export default __webpack_public_path__ + "static/media/castle.f1706588db268437a05ec740ca5bece2.svg";
export { ForwardRef as ReactComponent };